import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { ChatRecord } from "@/shared/domain/chat";
import { PaginatedResponse } from "@/shared/http";

export interface AdminChatsFilters {
  orgId?: string;
  createdBy?: string;
  sessionId?: string;
  hasErrors?: boolean;
  pageToken?: string;
  limit?: number;
}

export function useAdminChats(filters: AdminChatsFilters) {
  const { adminService } = useDomainServices();

  return useQuery<PaginatedResponse<ChatRecord>, Error>({
    queryKey: [
      "adminChats",
      filters.orgId,
      filters.createdBy,
      filters.sessionId,
      filters.hasErrors,
      filters.pageToken,
      filters.limit,
    ],
    queryFn: ({ signal }) => {
      return adminService.getAdminChats({
        orgId: filters.orgId,
        createdBy: filters.createdBy,
        sessionId: filters.sessionId,
        hasErrors: filters.hasErrors,
        pageToken: filters.pageToken,
        limit: filters.limit,
        abortSignal: signal,
      });
    },
    staleTime: 30000,
  });
}
